import { CLEAR_LOYALTY_ENROLMENT } from 'actions/actionConstants'
import { AnyAppAction } from 'actions/types/ActionTypes'

function clearLoyaltyEnrolment(): AnyAppAction {
  return {
    type: CLEAR_LOYALTY_ENROLMENT,
  }
}

export default clearLoyaltyEnrolment
